/** "3 min ago", "5 hr. ago", "2 days ago" in the user's language; "--" when never heard. */
export const formatLastHeard = (heardAt: number | null, now: number, locale: string): string => {
  if (heardAt === null) return "--";

  const seconds = Math.max(0, Math.round((now - heardAt) / 1000));
  let format: Intl.RelativeTimeFormat;

  try {
    format = new Intl.RelativeTimeFormat(locale || "en", { numeric: "auto", style: "short" });
  } catch {
    format = new Intl.RelativeTimeFormat("en", { numeric: "auto", style: "short" });
  }

  if (seconds < 60) return format.format(-seconds, "second");
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return format.format(-minutes, "minute");
  const hours = Math.round(minutes / 60);
  if (hours < 48) return format.format(-hours, "hour");
  return format.format(-Math.round(hours / 24), "day");
};

/** Badge for outlets with more than one machine, e.g. "3 machines" or "2 of 3 live". Null for single-machine outlets. */
export const machinesBadge = (
  machines: number,
  liveMachines: number,
  liveOnly: boolean,
  text: (key: string, fallback: string) => string
): string | null => {
  if (machines <= 1) return null;
  if (liveOnly && liveMachines < machines) {
    return text("badge_live_of", "%LIVE% of %N% live")
      .replace("%LIVE%", String(liveMachines))
      .replace("%N%", String(machines));
  }
  return text("badge_machines", "%N% machines").replace("%N%", String(machines));
};
